/* eslint-disable @typescript-eslint/no-explicit-any */
import { PortableText } from '@portabletext/react';
import * as React from 'react';

interface CourseDescriptionProps {
	description: string;
	content: any;
}

export function ServiceDescription({
	description,
	content,
}: CourseDescriptionProps) {
	return (
		<div>
			<p className='my-4 text-base leading-5 max-md:max-w-full'>
				{description}
			</p>
			<PortableText
				value={content}
				components={{
					block: {
						h1: ({ children }) => (
							<h1 className='text-3xl font-bold my-4'>{children}</h1>
						),
						h2: ({ children }) => (
							<h2 className='text-2xl font-bold my-3'>{children}</h2>
						),
						h3: ({ children }) => (
							<h3 className='text-xl font-bold my-2'>{children}</h3>
						),
						h4: ({ children }) => (
							<h4 className='text-lg font-semibold my-2'>{children}</h4>
						),
						normal: ({ children }) => <p className='mb-4'>{children}</p>,
						blockquote: ({ children }) => (
							<blockquote className='pl-4 border-l-4 border-gray-300 italic my-4'>
								{children}
							</blockquote>
						),
					},
					list: {
						bullet: ({ children }) => (
							<ul className='list-disc pl-6 mb-4'>{children}</ul>
						),
						number: ({ children }) => (
							<ol className='list-decimal pl-6 mb-4'>{children}</ol>
						),
					},
					marks: {
						strong: ({ children }) => (
							<strong className='font-bold'>{children}</strong>
						),
						em: ({ children }) => <em className='italic'>{children}</em>,
						link: ({ value, children }) => {
							const target = (value?.href || '').startsWith('http')
								? '_blank'
								: undefined;
							return (
								<a
									href={value?.href}
									target={target}
									rel={target === '_blank' ? 'noopener noreferrer' : undefined}
									className='text-blue-600 hover:underline'
								>
									{children}
								</a>
							);
						},
					},
				}}
			/>
		</div>
	);
}
